<section class="work" aria-label="Painel do controlador">
    <header class="banner">
        <h2>Painel Operacional do Controlador</h2>
        <p>Acompanhe seu rendimento mensal e registros de controles leiteiros.</p>
    </header>

    <div class="cards">
        <article class="card">
            <div class="card-head">
                <div>
                    <p class="label">Controles no mês</p>
                    <h3>{{ workLoading ? '—' : monthControlCount }}</h3>
                </div>
                <div class="icon"><mat-icon>fact_check</mat-icon></div>
            </div>
        </article>

        <article class="card">
            <div class="card-head">
                <div>
                    <p class="label">Produtores atendidos</p>
                    <h3>{{ workLoading ? '—' : monthProducerCount }} <span>produtores</span></h3>
                </div>
                <div class="icon alt"><mat-icon>agriculture</mat-icon></div>
            </div>
            <p class="foot">Produtores com controle no mês corrente</p>
        </article>
    </div>

    <article class="panel">
        <header class="panel-head">
            <div>
                <h3>Evolução mensal de controles</h3>
                <p>Histórico de controles realizados vs meta do controlador ({{ monthlyTarget }}/mês)</p>
            </div>
            <span class="tag">Últimos 6 meses</span>
        </header>
        <div class="chart-box">
            <canvas #evolution role="img" aria-label="Controles por mês comparados à meta"></canvas>
        </div>
    </article>

    <article class="panel">
        <header class="panel-head">
            <div>
                <h3>Controles leiteiros</h3>
                <p>Data oficial, animais e o envio do controle finalizado. Clique em um controle para abrir o relatório.</p>
            </div>
        </header>

        @if (workLoading) {
        <p class="state">Carregando controles…</p>
        } @else if (workError) {
        <p class="state error">Não foi possível carregar os controles.</p>
        } @else if (!work.controls.length) {
        <p class="state">Nenhum controle deste controlador ainda.</p>
        } @else {
        <div class="table-wrap">
            <table>
                <thead>
                    <tr>
                        <th>Data</th>
                        <th>Produtor / Propriedade</th>
                        <th>Animais</th>
                        <th>Envio</th>
                        <th class="right">Ação</th>
                    </tr>
                </thead>
                <tbody>
                    @for (row of work.controls; track row.id) {
                    <tr class="row" tabindex="0" role="button" title="Ver controle" (click)="onOpen(row)" (keydown.enter)="onOpen(row)">
                        <td>
                            <b>{{ formatDay(row.day) }}</b>
                            <small>{{ row.status === 'OPEN' ? 'Aberto' : 'Finalizado' }}{{ row.official ? ' · Oficial' : '' }}</small>
                        </td>
                        <td>
                            <b>{{ row.producerName }}</b>
                            <small>Código {{ row.producerCode || '—' }}</small>
                        </td>
                        <td>
                            <b>{{ row.animals }}</b>
                            <small>{{ row.milkingsCount || row.milkings?.length || 0 }} ordenhas</small>
                        </td>
                        <td>
                            <span class="pill" [class.ok]="row.sync === 'OK'" [class.bad]="row.sync === 'FAIL'" [class.warn]="row.sync === 'PENDING'" [class.off]="row.sync !== 'OK' && row.sync !== 'FAIL' && row.sync !== 'PENDING'">
                                {{ syncText(row.sync) }}
                            </span>
                        </td>
                        <td class="right">
                            <button type="button" class="btn-ghost" (click)="onPdf(row, $event)" [disabled]="pdfId === row.id">
                                <mat-icon>picture_as_pdf</mat-icon>
                                {{ pdfId === row.id ? 'Gerando…' : 'PDF' }}
                            </button>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
        }
    </article>

    <article class="panel">
        <header class="panel-head">
            <div>
                <h3>Eventos</h3>
                <p>O que este controlador enviou por último.</p>
            </div>
        </header>
        @if (!workLoading && !work.events.length) {
        <p class="state">Nenhum evento registrado.</p>
        } @else {
        <ul class="events">
            @for (event of work.events; track $index) {
            <li>
                <span class="when">{{ event.at | date: 'dd/MM HH:mm' : 'America/Sao_Paulo' }}</span>
                <span class="what">{{ actionText(event) }}</span>
                <span class="who">{{ producerOf(event.producerId) }}</span>
                <span class="pill" [class.ok]="event.sync === 'OK'" [class.bad]="event.sync === 'FAIL'" [class.warn]="event.sync === 'PENDING'" [class.off]="event.sync !== 'OK' && event.sync !== 'FAIL' && event.sync !== 'PENDING'">
                    {{ syncText(event.sync) }}
                </span>
            </li>
            }
        </ul>
        }
    </article>
</section>
